import xw from 'xwind';
import styled, { StyledComponent } from '@emotion/styled';
import { ButtonHTMLAttributes, HTMLAttributes } from 'react';

export const Container: StyledComponent<
  HTMLAttributes<HTMLElement>,
  HTMLAttributes<HTMLElement>,
  any
> = styled.article`
  ${xw`
    relative overflow-hidden
    mb-6 rounded-md shadow-lg sm[shadow-none]
    w-full flex flex-wrap flex-col
    sm[flex-row flex-nowrap pl-4]
    md[rounded-none pl-0 mb-0] lg:pl-0
  `}
`;

export const MediaContainer = styled.div(
  xw`
    relative w-full h-56 mb-6 bg-white
    sm[w-72 h-72 mb-0 rounded overflow-hidden]
  `,
);

export const CenterContainer = styled.div(
  xw`flex flex-col px-6 sm:flex-1 lg[pl-7 pr-6]`,
);

export const EndContainer = styled.div(
  xw`hidden md[flex flex-col items-end justify-between]`,
);

export const CollectionTitle = styled.div(
  xw`text-sm text-gray-500 m-1.5 sm[text-base mb-2.5]`,
);

export const Title = styled.div(
  xw`
    text-xl text-gray-900 mt-1 mb-2.5
    sm[text-2xl leading-10 mt-2.5]
  `,
);

export const Vendor = styled.p(
  xw`
    text-gray-400 text-sm sm:text-base
  `,
);

export const Price = styled.div(xw`text-lg md:text-2xl`);

export const QuantityInput = styled.input`
  ${xw`sm:w-20 p-2 text-secondary focus:outline-none border border-secondary border-solid rounded-sm text-center md:text-left mt-1`}
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    opacity: 1;
    cursor: pointer;
  }
`;

export const ButtonLink = styled.button`
  ${xw`
    flex justify-center items-center w-32
    bg-primary text-base text-white rounded-full
    px-4 outline-none focus:outline-none
  `}

  height: 42px;
`;

export const ButtonLinkCart = styled.button(
  xw`
    text-xl text-primary underline
    outline-none focus:outline-none
  `,
);

export const StyledRemoveButtonIcon: StyledComponent<
  ButtonHTMLAttributes<HTMLButtonElement>,
  ButtonHTMLAttributes<HTMLButtonElement>,
  any
> = styled.button(
  xw`
    w-6 h-6 md:hidden
    absolute right-5 md:right-0 top-2.5
    flex justify-center items-center
    bg-secondary rounded-full z-10 focus:outline-none
  `,
);
